import MuiMenuItem, { MenuItemProps } from "@mui/material/MenuItem";
import { styled } from "@mui/material/styles";

const MenuItem = styled((props: MenuItemProps) => <MuiMenuItem {...props} />)(
  ({ theme }) => ({
    margin: theme.spacing(1),
    padding: theme.spacing(1),
    borderRadius: "8px",
    "&:hover": { backgroundColor: theme.palette.states.hover },
    "&.Mui-selected": {
      backgroundColor: "transparent",
      "&:hover": { backgroundColor: theme.palette.states.hover },
      "&.Mui-focusVisible": {
        backgroundColor: theme.palette.states.hover,
      },
    },
    "&.Mui-focusVisible": {
      backgroundColor: theme.palette.states.hover,
    },
    "&:first-of-type": { marginTop: 0 },
    "&:last-child": { marginBottom: 0 },
    whiteSpace: "normal",
  })
);
export default MenuItem;
